<template>
  <div class="button-container" :style="{ 'justify-content': actionType !== 'view' ? 'space-between' : 'flex-end' }">
    <management-button v-if="actionType !== 'view'" :label="$t('Delete' + objectType)" type="cancel" :align="'left'" @buttonClick="$emit('delete-item')"></management-button>
  </div>
</template>

<script>
import ManagementButton from "@/components/Management/ManagementButton";

export default {
  name: "PlanningDetailsTableButtons",

  components: {
    ManagementButton
  },

  props: {
    objectType: {
      type: String
    },

    actionType: {
      type: String
    }
  }
}
</script>

<style>
.button-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 15px
}

.cancel-apply-buttons-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap-reverse;
  justify-content: flex-end;
}
</style>


// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Buildings/Vertical/PlanningDetailsTableButtons.vue